import { Form, Input, Switch } from "antd";
import { forwardRef } from "react";

const EditMenu = forwardRef(({ info, dataSource }, languageRef) => {

  function validatorKor(_, value) {
    const newData = languageRef.current.getFieldsValue();

    for (let el of dataSource) {
      if (el.code !== newData.code && el.name_kor === newData.name_kor) {
        return Promise.reject(
          new Error(`언어명칭(한국어) "${el.name_kor}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  }
  function validatorNative(_, value) {
    const newData = languageRef.current.getFieldsValue();

    for (let el of dataSource) {
      if (el.code !== newData.code && el.name_native === newData.name_native) {
        return Promise.reject(
          new Error(`언어명칭(모국어) "${el.name_native}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  }
  function validatorlocale(_, value) {
    const newData = languageRef.current.getFieldsValue();

    for (let el of dataSource) {
      if (el.code !== newData.code && el.locale === newData.locale) {
        return Promise.reject(
          new Error(`언어약칭코드 "${el.locale}"가 이미 존재합니다.`)
        );
      }
    }
    return Promise.resolve();
  }

  return (
    <div>
      <Form
        ref={languageRef}
        layout="vertical"
        initialValues={{
          code: info.code,
          name_kor: info.name_kor,
          name_native: info.name_native,
          locale: info.locale,
          voice_file_speaker: info.voice_file_speaker,
          use_yn: info.use_yn === "Y" ? true : false,
          delete_yn: info.delete_yn === "Y" ? true : false
        }}
      >
        <Form.Item name="code" label="언어코드">
          <Input disabled={true}></Input>
        </Form.Item>
        <Form.Item
          name="name_kor"
          label="언어 명칭(한국어)"
          rules={[
            { required: true, message: "언어 명칭(한국어)을 입력해 주세요." },
            { validator: validatorKor },
          ]}
        >
          <Input></Input>
        </Form.Item>
        <Form.Item
          name="name_native"
          label="언어 명칭(모국어)"
          rules={[
            { required: true, message: "언어 명칭(모국어)을 입력해 주세요." },
            { validator: validatorNative },
          ]}
        >
          <Input></Input>
        </Form.Item>

        <Form.Item
          name="locale"
          label="언어약칭코드"
          rules={[
            { required: true, message: "언어약칭코드를 입력해 주세요." },
            { validator: validatorlocale },
          ]}
        >
          <Input></Input>
        </Form.Item>

        <Form.Item
          name="voice_file_speaker"
          label="음성파일 화자"
          rules={[
            { required: true, message: "화자를 입력해 주세요." },
          ]}
        >
          <Input></Input>
        </Form.Item>

        <Form.Item
          name="use_yn"
          label="사용 가능 여부"
          valuePropName="checked"
          required={true}
        >
          <Switch />
        </Form.Item>
        
        <Form.Item
          name="delete_yn"
          label="삭제 여부"
          valuePropName="checked"
          required={true}
          hidden={true}
        >
          <Switch />
        </Form.Item>
      </Form>
    </div>
  );
});
export default EditMenu;
